// Polish → English country name mapping for i18n
const PL_TO_EN: Record<string, string> = {
  'Afganistan': 'Afghanistan', 'Albania': 'Albania', 'Algieria': 'Algeria', 'Andora': 'Andorra',
  'Angola': 'Angola', 'Arabia Saudyjska': 'Saudi Arabia', 'Argentyna': 'Argentina',
  'Armenia': 'Armenia', 'Australia': 'Australia', 'Austria': 'Austria', 'Azerbejdżan': 'Azerbaijan',
  'Bangladesz': 'Bangladesh', 'Belgia': 'Belgium', 'Białoruś': 'Belarus', 'Bośnia i Hercegowina': 'Bosnia and Herzegovina',
  'Brazylia': 'Brazil', 'Bułgaria': 'Bulgaria', 'Chile': 'Chile', 'Chiny': 'China',
  'Chorwacja': 'Croatia', 'Cypr': 'Cyprus', 'Czarnogóra': 'Montenegro', 'Czechy': 'Czech Republic',
  'Dania': 'Denmark', 'Egipt': 'Egypt', 'Ekwador': 'Ecuador', 'Estonia': 'Estonia',
  'Etiopia': 'Ethiopia', 'Filipiny': 'Philippines', 'Finlandia': 'Finland', 'Francja': 'France',
  'Grecia': 'Greece', 'Grecja': 'Greece', 'Gruzja': 'Georgia', 'Hiszpania': 'Spain',
  'Holandia': 'Netherlands', 'Indie': 'India', 'Indonezja': 'Indonesia', 'Irak': 'Iraq',
  'Iran': 'Iran', 'Irlandia': 'Ireland', 'Islandia': 'Iceland', 'Izrael': 'Israel',
  'Japonia': 'Japan', 'Jordania': 'Jordan', 'Kambodża': 'Cambodia', 'Kanada': 'Canada',
  'Katar': 'Qatar', 'Kazachstan': 'Kazakhstan', 'Kenia': 'Kenya', 'Kolumbia': 'Colombia',
  'Korea Południowa': 'South Korea', 'Korea Północna': 'North Korea', 'Kosowo': 'Kosovo',
  'Kuba': 'Cuba', 'Kuwejt': 'Kuwait', 'Laos': 'Laos', 'Liban': 'Lebanon',
  'Libia': 'Libya', 'Liechtenstein': 'Liechtenstein', 'Litwa': 'Lithuania', 'Luksemburg': 'Luxembourg',
  'Łotwa': 'Latvia', 'Macedonia Północna': 'North Macedonia', 'Malezja': 'Malaysia',
  'Malta': 'Malta', 'Maroko': 'Morocco', 'Meksyk': 'Mexico', 'Mołdawia': 'Moldova',
  'Monako': 'Monaco', 'Mongolia': 'Mongolia', 'Niderlandy': 'Netherlands', 'Niemcy': 'Germany',
  'Nigeria': 'Nigeria', 'Norwegia': 'Norway', 'Nowa Zelandia': 'New Zealand',
  'Oman': 'Oman', 'Pakistan': 'Pakistan', 'Palestyna': 'Palestine', 'Panama': 'Panama',
  'Peru': 'Peru', 'Polska': 'Poland', 'Portugalia': 'Portugal', 'Republika Południowej Afryki': 'South Africa',
  'Rosja': 'Russia', 'Rumunia': 'Romania', 'San Marino': 'San Marino', 'Senegal': 'Senegal',
  'Serbia': 'Serbia', 'Singapur': 'Singapore', 'Słowacja': 'Slovakia', 'Słowenia': 'Slovenia',
  'Stany Zjednoczone': 'United States', 'Syria': 'Syria', 'Szwajcaria': 'Switzerland',
  'Szwecja': 'Sweden', 'Tadżykistan': 'Tajikistan', 'Tajlandia': 'Thailand', 'Tajwan': 'Taiwan',
  'Tanzania': 'Tanzania', 'Tunezja': 'Tunisia', 'Turcja': 'Turkey', 'Turkmenistan': 'Turkmenistan',
  'Ukraina': 'Ukraine', 'Urugwaj': 'Uruguay', 'Uzbekistan': 'Uzbekistan', 'Watykan': 'Vatican City',
  'Wenezuela': 'Venezuela', 'Węgry': 'Hungary', 'Wielka Brytania': 'United Kingdom',
  'Wietnam': 'Vietnam', 'Włochy': 'Italy', 'Wybrzeże Kości Słoniowej': 'Ivory Coast',
  'Zjednoczone Emiraty Arabskie': 'United Arab Emirates',
}

/**
 * Translate a country name from Polish to the active language.
 * Returns the original name if no translation is found or language is Polish.
 */
export const translateCountryName = (name: string, langCode: string): string => {
  if (!name || langCode === 'pl') return name
  return PL_TO_EN[name] || name
}
